import { render, staticRenderFns } from "./DraggableFields.vue?vue&type=template&id=497619bf&scoped=true&"
import script from "./DraggableFields.vue?vue&type=script&lang=js&"
export * from "./DraggableFields.vue?vue&type=script&lang=js&"
import style0 from "./DraggableFields.vue?vue&type=style&index=0&id=497619bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497619bf",
  null
  
)

export default component.exports